/**
 * Ключ тексту помилки дій «Облікових записів» і «Демо-офісів спостерігача» (чиста функція): коди сервера (409 self, 409 last_admin), 404 і 403;
 * інша помилка — загальний текст.
 */
export function accountErrorKey(error: unknown): string {
  const e = (error && typeof error === 'object' ? error : {}) as { code?: unknown; status?: unknown };
  if (e.code === 'self' || e.code === 'last_admin') return `sysAccounts.errors.${e.code}`;
  if (e.status === 404 || e.code === 'not_found') return 'sysAccounts.errors.not_found';
  if (e.status === 403 || e.code === 'forbidden') return 'sysAccounts.errors.forbidden';
  return 'sysAccounts.errors.failed';
}
